import React from 'react';
import './index.css';
import LandingPage from './LandingPage';
import PdfToExcel from './pages/PdfToExcel';
import PdfToWord from './pages/PdfToWord';
import PdfToImage from './pages/PdfToImage';
import PdfToPptx from './pages/PdfToPptx';
import ChatWithPdf from './pages/ChatWithPdf';
import MergePdf from './pages/MergePdf';
import SplitRemoveRotatePdf from './pages/SplitRemoveRotatePdf';
import ProtectPdf from './pages/ProtectPdf';
import UnlockPdf from './pages/UnlockPdf';
import TransformPdf from './pages/TransformPdf';
import CompressPdf from './pages/CompressPdf';
import DiagnosePdf from './pages/DiagnosePdf';
import NotFound from './pages/NotFound';

// Get the initial path in a way that works with SSR
function getInitialPath() {
  if (typeof window === 'undefined') {
    return '/'; // Default for SSR
  }
  // Remove trailing slash except for root path
  let path = window.location.pathname;
  if (path !== '/' && path.endsWith('/')) {
    path = path.slice(0, -1);
  }
  return path;
}

export default function App() {
  // Initialize with the actual path to match what react-snap pre-rendered
  const [path, setPath] = React.useState(getInitialPath);
  
  React.useEffect(() => {
    // Ensure we have the correct path after hydration
    let currentPath = window.location.pathname;
    if (currentPath !== '/' && currentPath.endsWith('/')) {
      currentPath = currentPath.slice(0, -1);
    }
    if (path !== currentPath) {
      setPath(currentPath);
    }
    
    // Update path on client-side navigation
    const handlePopState = () => {
      let newPath = window.location.pathname;
      if (newPath !== '/' && newPath.endsWith('/')) {
        newPath = newPath.slice(0, -1);
      }
      setPath(newPath);
    };
    
    // Listen for browser navigation
    window.addEventListener('popstate', handlePopState);
    
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [path]);
  
  // Route components based on path
  switch (path) {
    case '/pdf-to-excel':
      return <PdfToExcel />;
    case '/pdf-to-word':
      return <PdfToWord />;
    case '/pdf-to-image':
      return <PdfToImage />;
    case '/pdf-to-powerpoint':
      return <PdfToPptx />;
    case '/chat-with-pdf':
      return <ChatWithPdf />;
    case '/merge-pdf':
      return <MergePdf />;
    case '/split-remove-rotate-pdf':
      return <SplitRemoveRotatePdf />;
    case '/protect-pdf':
      return <ProtectPdf />;
    case '/unlock-pdf':
      return <UnlockPdf />;
    case '/transform-pdf':
      return <TransformPdf />;
    case '/compress-pdf':
      return <CompressPdf />;
    case '/diagnose-pdf':
      return <DiagnosePdf />;
    case '/protect-unlock-pdf':
      // Redirect old URL to new Protect PDF page
      window.history.replaceState(null, '', '/protect-pdf');
      return <ProtectPdf />;
    case '/':
      return <LandingPage />;
    default:
      // Return 404 page for unknown routes
      return <NotFound />;
  }
}
